"use client";

import React from "react";
import BenefitCard from "./BenefitCard";
import { useGlobalStore } from "@/app/context/globalStoreProvider";
import { DEFAULT_CASHBACK_PERCENTAGE } from "@/lib/utils";

const BenefitCardsSection: React.FC = () => {
  const { user } = useGlobalStore();
  const cashbackPercentage =
    user?.data?.cashbackPercentage ?? DEFAULT_CASHBACK_PERCENTAGE;

  return (
    <>
      <div className="mt-10 flex max-w-[650px] flex-col items-center justify-start gap-6">
        <div className="text-linear-gradient-default text-center text-4xl leading-[1.2] md:text-6xl">
          The best place to book hotels
        </div>
      </div>
      <div className="mt-5 flex flex-col gap-5 md:flex-row">
        <BenefitCard
          title="Get the lowest rate"
          description="Gondola AI agents search the web to ensure you get the lowest possible member rates"
          image="/assets/landing-page/benefit-icon/value.svg"
        />
        <BenefitCard
          title="Maximize your earnings"
          description={`Earn the maximum points from your credit card and loyalty programs. We give you an additional ${Math.round(cashbackPercentage * 100)}% cash back`}
          image="/assets/landing-page/benefit-icon/simplifed.svg"
        />
        <BenefitCard
          title="AI that understands you"
          description="Gondola recommends hotels you will love based on your preferences and where you've stayed in the past"
          image="/assets/landing-page/benefit-icon/trip.svg"
        />
      </div>
    </>
  );
};

export default BenefitCardsSection;
